// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"ec4d7774","755":"15072a75"}[chunkId] + ".chunk.js";
};